import { useState } from "react";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter,
  DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldAlert } from "lucide-react";

export default function MasterPasswordDialog({
  open, onOpenChange, onConfirm, title = "Autorização Master",
  description = "Essa ação excede o quadro aprovado do setor. Informe a senha Master para autorizar.",
}) {
  const [pwd, setPwd] = useState("");
  const [justification, setJustification] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await onConfirm({ password: pwd, justification });
      onOpenChange(false);
      setPwd(""); setJustification("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="master-password-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <span className="grid h-8 w-8 place-items-center rounded-md bg-amber-50 text-amber-700">
              <ShieldAlert className="h-4 w-4" />
            </span>
            <DialogTitle className="font-display">{title}</DialogTitle>
          </div>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div>
            <Label htmlFor="justif" className="text-[11px] uppercase tracking-wider">Justificativa (obrigatória)</Label>
            <Input
              id="justif"
              value={justification}
              onChange={(e) => setJustification(e.target.value)}
              placeholder="Motivo do excesso de quadro"
              data-testid="master-justification-input"
            />
          </div>
          <div>
            <Label htmlFor="master" className="text-[11px] uppercase tracking-wider">Senha Master</Label>
            <Input
              id="master"
              type="password"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              placeholder="••••••••"
              data-testid="master-password-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="master-cancel-btn">
            Cancelar
          </Button>
          <Button
            onClick={submit}
            disabled={!pwd || !justification || loading}
            className="bg-[#234935] hover:bg-[#2c5c43]"
            data-testid="master-confirm-btn"
          >
            {loading ? "Autorizando..." : "Autorizar e Continuar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
